import React from 'react';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import Fs3ChartsBoxContent from 'ui-elements/boxes/Fs3BarChartsBoxContent';
import reportLocales from 'globals/locales/report';
import { observer } from 'mobx-react';
import { useReportContext } from 'contexts/report/ReportContext';
import { isSuccessState } from 'globals/utils';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { Fade } from '@material-ui/core';
import { getHelperTooltipContent } from 'ui-elements/modals/FsDefaultDialog/FsDefaultDialog.utils';

// Locales
const { title, tooltipInfo } = reportLocales.liquidity;

const Liquidity: React.FC = () => {
  const {
    report: {
      liquidity: { status, graphsValues, infoBoxes },
    },
  } = useReportContext();

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
        withMargin={false}
      />
    );
  return (
    <Fade in={isSuccessState(status)} timeout={1000}>
      <FsPaper
        title={title}
        tooltipContent={getHelperTooltipContent(tooltipInfo)}
        data-test="liquidity-component"
      >
        <Fs3ChartsBoxContent graphs={graphsValues()} infoBoxItems={infoBoxes} />
      </FsPaper>
    </Fade>
  );
};

Liquidity.displayName = 'Liquidity';

export default observer(Liquidity);
